import React, { useState } from 'react'
import { Button, Modal, Form, Typography } from 'antd'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'

import { uploadExternalFile } from 'states/modules/question'
import FileUpload from '../../../components/fileUpload'

const { Title } = Typography
const { Text } = Typography

const UploadDocumentModal = ({ onClose, showModal }) => {
	const [form] = Form.useForm()
	const [uploadDocument, setUploadDocument] = useState(null)
	const [previousFileId, setPreviousFileId] = useState('')
	const dispatch = useDispatch()

	const handleUploadedExternalFile = (UploadedExternalFile) => {
		dispatch(uploadExternalFile({ uploadedFile: UploadedExternalFile[0] }))
	}

	const handleFileChange = (files) => {
		if (files.length !== 0 && files[0].uid !== previousFileId) {
			setUploadDocument(files)
			handleUploadedExternalFile(files)
			setPreviousFileId(files[0].uid)
		}
	}

	const getFooterModal = () => (
		<div
			style={{
				display: 'flex',
				flexDirection: 'row',
				justifyContent: 'flex-end',
			}}>
			<Button
				style={{ marginLeft: 30 }}
				type="primary"
				key="enviar"
				onClick={onClose}
				form="uploadDocumentForm"
				disabled={!uploadDocument}>
				Enviar
			</Button>
		</div>
	)

	return (
		<StyledModal open={showModal} closable={false} destroyOnClose footer={null}>
			<Form form={form} id="uploadDocumentForm">
				<Title
					level={4}
					style={{
						color: 'rgba(0, 0, 0, 0.45)',
						textAlign: 'center',
						marginBottom: 0,
					}}>
					Enviar documento
				</Title>
				<NewDivider />

				<>
					<StyledItemForm label="Upload Documento" name="Upload Documento">
						<FileUpload
							onChange={handleFileChange}
							metadata={{ extract_text: 'true' }}
							multiple={false}
							duplicateToContext={false}
						/>
						<Text
							type="secondary"
							style={{
								fontSize: '12px',
								display: 'block',
								marginTop: '8px',
							}}>
							* Apenas arquivos PDF de até 10MB são permitidos.
						</Text>
					</StyledItemForm>
				</>

				<NewDivider />
				{getFooterModal()}
			</Form>
		</StyledModal>
	)
}

UploadDocumentModal.propTypes = {
	onCancel: PropTypes.func,
	showModal: PropTypes.bool,
}

export default UploadDocumentModal

const StyledItemForm = styled(Form.Item)`
	.ant-form-item-label {
		padding: 0;
	}
`

const NewDivider = styled.div`
	background: rgba(0, 0, 0, 0.25);
	height: 0.8px;
	margin: 28px 0;
`

const StyledModal = styled(Modal)`
	.ant-modal-body {
		padding: 28px;
	}
`
